import React, { CSSProperties } from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';

export interface CardBoxProps {
  title?: React.ReactNode;
  children: React.ReactNode;
  extraContent?: React.ReactNode;
  subTitle?: React.ReactNode;
  style?: CSSProperties;
  showIcon?: boolean;
  className?: string;
}

const CardBox: React.FC<CardBoxProps> = props => {
  const { title, style, extraContent, className, subTitle } = props;

  return (
    <div className={styles.personalFormContainer} style={style}>
      <div className={styles.headerWrapper}>
        {title ? <div className={styles.formTitle}>{title}</div> : <div />}
        {subTitle ? <div className={styles.subTitle}>{subTitle}</div> : <div className={styles.subTitle} />}
        {extraContent ? extraContent : <div />}
      </div>

      <div className={classNames(styles.content, className)}>{props.children}</div>
    </div>
  );
};

export default CardBox;
